module.exports = __webpack_public_path__ + "static/media/CR-map-cutout-VP.e0855b73.png";